import {
    CONFIRMED_CREATE_SHOP_ACTION,
    CONFIRMED_DELETE_SHOP_ACTION,
    CONFIRMED_EDIT_SHOP_ACTION,
    CONFIRMED_GET_SHOPS,
    CREATE_SHOP_ACTION,    
    CREATE_SHOP_ERROR_ACTION,
    CLEAR_SHOP_ERROR
} from '../actions/ShopTypes';

const initialState = {
    shops: [],
    createShopError:{}
};

export default function ShopsReducer(state = initialState, actions) {
    if (actions.type === CREATE_SHOP_ACTION) { 
        const shops = [...state.shops];        
        return {
            ...state,
            shops,
        };
    }

    if (actions.type === CONFIRMED_DELETE_SHOP_ACTION) {
        const shops = [...state.shops];
        const postIndex = shops.findIndex(
            (post) => post.id === actions.payload,
        );
        shops.splice(postIndex, 1);
        return {
            ...state,
            shops,
        };
    }

    if (actions.type === CONFIRMED_EDIT_SHOP_ACTION) {
        const shops = [...state.shops];
        const postIndex = shops.findIndex(
            (post) => post.id === actions.payload.id,
        );

        shops[postIndex] = actions.payload;
        return {
            ...state,
            shops,
        };
    }

    if (actions.type === CONFIRMED_CREATE_SHOP_ACTION) {
        const shops = [...state.shops];
        //shops.push(actions.payload);

        return {
            ...state,
            shops,
        };
    }

    if (actions.type === CONFIRMED_GET_SHOPS) {
        return {
            ...state,
            shops: actions.payload,
        };
    }
    if (actions.type === CREATE_SHOP_ERROR_ACTION) {
        return {
            ...state,
            createShopError: actions.payload,
        };
    }

    if (actions.type === CLEAR_SHOP_ERROR) {
        return {
            ...state,
            createShopError: {},
        };
    }
    return state;
}


